import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import {
  CarDto,
  CarListItemDto,
  CreateCarDto,
  UpdateCarDto,
} from './car.interface';

@Injectable({
  providedIn: 'root',
})
export class CarsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly globals: Globals = inject(Globals);

  //#region create
  add(car: CreateCarDto): Observable<CarDto> {
    const url = `${this.globals.apiRoot}/jwtCars`;
    return this.http.post<CarDto>(url, car);
  }
  //#endregion

  //#region read
  getAll(chargingStationId?: number): Observable<CarListItemDto[]> {
    const url = chargingStationId
      ? `${this.globals.apiRoot}/jwtCars?smartChargingStationId=${chargingStationId}`
      : `${this.globals.apiRoot}/jwtCars`;
    return this.http.get<CarListItemDto[]>(url);
  }

  getById(id: number): Observable<CarDto> {
    const url = `${this.globals.apiRoot}/jwtCars/${id}`;
    return this.http.get<CarDto>(url);
  }

  getByUid(uid: string): Observable<CarDto> {
    const url = `${this.globals.apiRoot}/jwtCars/uid/${uid}`;
    return this.http.get<CarDto>(url);
  }
  //#endregion

  //#region update
  update(id: number, car: UpdateCarDto): Observable<CarDto> {
    const url = `${this.globals.apiRoot}/jwtCars/${id}`;
    return this.http.put<CarDto>(url, car);
  }

  move(
    id: number,
    newPosition: number,
  ): Observable<{ readonly carId: number; readonly position: number }[]> {
    const url = `${this.globals.apiRoot}/jwtCars/${id}/move`;
    return this.http.put<
      { readonly carId: number; readonly position: number }[]
    >(url, newPosition);
  }
  //#endregion

  //#region delete
  delete(id: number): Observable<CarDto> {
    const url = `${this.globals.apiRoot}/jwtCars/${id}`;
    return this.http.delete<CarDto>(url);
  }
  //#endregion
}
